export default __webpack_public_path__ + "static/media/zoo_oring.1cb23415.svg";